<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div>
    <v-overlay

    ></v-overlay>

    <v-navigation-drawer
        permanent right
        absolute
        class="view"
        width="800"
    >
      <!--<v-card>-->
      <v-btn fab small fixed top left outlined color="primary"
             @click="onClickPrevious()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn fab small fixed top right outlined color="primary"
             @click="onClickNext()">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>


      <v-content v-if="activeTab==='Info'">
        <v-card-title class="headline">{{current_order.code}}</v-card-title>
        <!--<v-card-text>Info</v-card-text>-->

        <div class="contents">
          <v-card>
            <v-container class="container--fluid pt-0">
              <v-row>
                <v-col>

                  รหัสลูกค้า:
                  <TypeBadge v-if="order.customer" :small="true" :type="order.customer.type"></TypeBadge>
                  {{current_order.customer && current_order.customer_code}} <br/>
                  ชื่อลูกค้า: {{current_order.customer && current_order.customer.nickname}}<br/>
                  ที่อยู่: {{order.customer.address}}<br/>
                  {{order.customer.district}}
                  {{order.customer.province}} {{order.customer.zip_code}}
                </v-col>
                <v-col class="col-4">
                  หมายเหตุ:
                  {{order.comment}}
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <!--{{order}}-->


          <v-simple-table class="itemTable">
            <template v-slot:default>
              <thead>
              <tr class="ItemHead">
                <th class="text-left">รายการ</th>
                <!--<th class="text-right">ราคาขาย</th>-->
                <th class="text-right">ราคา</th>
                <th class="text-right">ลดใน</th>
                <th class="text-right">ส่วนลด</th>
                <th class="text-right">จน.</th>
                <th class="text-right">ex.vat</th>
                <th class="text-right">ลดนอก</th>
                <!--<th class="text-right">รวม in.vat</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in order.items"
                  :item="item"
                  :key="index"
                  :items="order.items"
                  :currentIndex="index"

                  class="ItemRow"
              >
                <td>{{item.index_no}}.) {{ (item.product?item.product.nickname:null) || item.product_code}}</td>
                <!--<td class="text-right">{{ number_format(item.price_init,2,2)}}</td>-->
                <td class="text-right">{{ number_format(item.price_ex_vat,2,2)}}</td>
                <td class="text-right">{{ number_format(item.discount_internal_amount,2,2)}}</td>
                <td class="text-right">{{
                  number_format(item.discount_internal_amount,2,2)}}
                </td>
                <td class="text-right">{{ number_format(item.quantity)}}</td>
                <td class="text-right">{{ number_format(item.total_gross,2,2)}}</td>
                <td class="text-right">{{ item.discount_external_amount ?
                  number_format(item.discount_external_amount,2,2):''}}
                </td>
                <!--<td class="text-right">{{ number_format(item.total_net,2,2)}}</td>-->

              </tr>
              </tbody>
            </template>
          </v-simple-table>


          <v-footer class="pb-10">
            <v-container>
              <v-row>
                <v-col>
                  เซลล์ <span>คอมฯนอก {{$helper.number_format(order.total_external_discount,2)}} บาท</span>
                  <v-divider class="mb-4"></v-divider>
                  <Avatar v-for="sale in sales" :active="true" :user="sale" v-bind:key="sale.id"></Avatar>

                  <v-avatar

                      v-if="!sales || sales.length===0"
                      size="64px"
                      color="grey"
                  >
                    <v-icon x-large>mdi-plus</v-icon>
                  </v-avatar>
                </v-col>
                <v-col class="col-2 text-right">
                  Gross<br/>
                  Vat<br/>
                  Net
                </v-col>
                <v-col class="col-2 text-right">
                  {{number_format(order.total_gross,2)}}<br/>
                  {{number_format(order.total_vat,2)}}<br/>
                  {{number_format(order.total_net,2)}}
                </v-col>
              </v-row>
              <v-row v-if="order.status===orderConst.STATUS_SUBMITTED_PENDING_CONFIRM">
                <v-col>

                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="CancelOrder()">
                    ยกเลิก
                  </v-btn>
                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="success" tile @click="ConfirmOrder()">
                    ยืนยัน
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="order.status===orderConst.STATUS_SUBMITTED_PENDING_APPROVE">
                <v-col>

                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="RejectOrder()">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApproveOrder()">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-footer>
        </div>
      </v-content>


      <v-content v-if="activeTab==='Timeline'">
        <v-card-title class="headline">{{current_order.code}}</v-card-title>
        <v-card-text>Timeline</v-card-text>


      </v-content>


      <v-app-bar fixed bottom height="60">
        <!--<v-footer bottom>-->
        <!--<template v-slot:default>-->
        <v-tabs
            bottom
            fixed

            height="60"
            slider-size="5"
            slider-color="slider"
            centered
            center-active
        >


          <TabForDialog v-for="(tab, index) in tabs" :key="index" :tab="tab"></TabForDialog>

        </v-tabs>
        <!--</template>-->
      </v-app-bar>

      <v-btn float fab fixed bottom right class="close-button" color="primary"
             @click="$store.commit('dialog_is_order',{toggle:false})">
        <v-icon>mdi-close</v-icon>
      </v-btn>


      <!--</v-card>-->
      <!--</v-dialog>-->
    </v-navigation-drawer>

  </div>
</template>
<style lang="scss" scoped>
  .contents {
    height: calc(100vh - 80px);
    overflow: auto;
  }

  .headline {
    padding-top: 20px;
    padding-bottom: 0;
    height: 56px;
  }

  .overlay {
    z-index: 5 !important;
  }

  .view {
    z-index: 6 !important;
    .v-card__title {
      padding-left: 68px;
      padding-right: 68px;
    }
    .v-app-bar {
      padding-right: 96px;
    }
  }

  .list-container {
    .list-row {
      position: relative;
      height: auto;
      margin-left: 0;
    }
    .list-row {
      font-size: 20px;
    }
    @media all and (max-width: 599px) {
      .list-row {
        font-size: 16px;
      }
    }
    @media all and (min-width: 600px) and (max-width: 720px) {
      .list-row {
        font-size: 18px;
      }
    }
    @media all and (min-width: 720px) and (max-width: 960px) {
      .list-row {
        font-size: 20px;
      }
    }
  }

  .itemTable {

    line-height: 1.2;
  }

  .ItemHead {
    th {
      font-size: 16px;
    }
  }

  .ItemRow {
    td {
      font-size: 16px;
      padding: 0 4px;
    }
    td:first-child {
      font-size: 16px;
      padding-left: 8px;
    }
    td:last-child {
      padding-right: 8px;
    }
  }

</style>

<script lang="ts">

  import {Component, Vue} from 'vue-property-decorator'
  import TypeBadge from '../components/Customer/TypeBadge.vue'
  import ItemRow from '../components/Order/ItemRow.vue'
  import TabForDialog from '../components/TabForDialog.vue'
  import Avatar from '../components/User/Avatar.vue'
  import {DataOrder, Order, OrderConst} from '../models/Order'
  import {User} from '../models/User'
  import router from '../router'
  import Helper from '../services/Helper.js'

  @Component({
    components: {Avatar, TypeBadge, TabForDialog, ItemRow},
  })
  export default class OrderOldDialog extends Vue {
    number_format = Helper.number_format

    activeTab: string = 'Info'

    orderConst = OrderConst

    tabs_info = {
      name: 'ข้อมูล',
      click: () => this.click_tab('Info'),
      path: null,
      permissions: [],
      isLoad: false,
      badge: false,
      badge_number: 0,
    }
    tabs_timeline = {
      name: 'Timeline',
      click: () => this.click_tab('Timeline'),
      path: null,
      permissions: [],
      isLoad: false,
      badge: true,
      badge_number: 5,
    }

    tabs = [
      this.tabs_info,
    ]
    dialog: boolean = false

    get current_order(): Order {
      return this.$store.state.orders.data[this.$store.state.orders.current]
    }

    onClickPrevious() {

      this.$store.commit('order_current', -1)
      this.getOrder()
    }

    onClickNext() {
      this.$store.commit('order_current', 1)
      this.getOrder()
    }

    click_tab(name: string): void {
      if (name === 'Cart') {
        this.$store.commit('dialog_is_order', {toggle: false})
        router.push('/cart')
      } else {
        this.activeTab = name

      }

    }

    mounted() {
      this.getOrder()
    }

    order: Order = new Order()
    isLoadOrder = false

    getOrder() {
      if (this.$store.state.orders.data) {
        const id = this.$store.state.orders.data[this.$store.state.orders.current].id
        this.tabs_info.isLoad = true
        Helper.get(Helper.setting.order.getResourceAPI.replace('{id}', id))
          .then<{ data: DataOrder }>(({data}) => {

            console.log('getOrder', data.data)
            this.order = data.data

            this.refreshSale()
            // this.items = data.data

            //this.$store.commit('orders_response', data)
            //this.reloadItem()
            this.tabs_info.isLoad = false
          })
      }
    }


    is_LoadSubmitOrder = false

    async ApproveOrder() {
      await this.SetOrderStatus(OrderConst.STATUS_APPROVED_PENDING_SYNC)
    }

    async RejectOrder() {
      await this.SetOrderStatus(OrderConst.STATUS_REJECT)
    }

    async CancelOrder() {
      await this.SetOrderStatus(OrderConst.STATUS_CART)
      this.$store.commit('dialog_is_order', {toggle: false})
    }

    async ConfirmOrder() {
      await this.SetOrderStatus(OrderConst.STATUS_SUBMITTED_PENDING_APPROVE)
    }

    async SetOrderStatus(status: number) {
      let order: Order = new Order()
      order.id = this.order.id
      order.mode = 'status'
      if (!order.hasOwnProperty('SetStatus')) {
        order = Object.setPrototypeOf(order, Order.prototype)
      }
      this.is_LoadSubmitOrder = true
      // debugger
      try {
        order = await order.SetStatus(status)
        this.order = order
      } catch (e) {
        // alert(e);
      }
      this.$store.commit('orders_update', {index: this.$store.state.orders.current, order})
      this.is_LoadSubmitOrder = false
    }

    sales: User[] = []

    private refreshSale() {
      this.sales = []
      console.log('order sales', this.order.sales)
      for (let index in this.order.sales) {
        let sale = this.order.sales[index]
        if (!sale || !sale.user_code) continue
        console.log('sales', sale)
        if (this.$store.state.users.code_map.hasOwnProperty(sale.user_code)) {
          let user = this.$store.state.users.code_map[sale.user_code]
          user.orderUser = sale
          this.sales.push(user)
        } else {
          let sale2 = new User()
          sale2.department = '??'
          sale2.nickname = sale.user_code
          sale2.picture = null
          sale2.orderUser = sale
          this.sales.push(sale2)
        }
      }
    }

  }

</script>
